<template>
    <div v-if="showBottomNav" class="bottom-bar-wrapper flex justify-center" :class="!isCableAccessoriesPage && !isOnCableSelection && 'sticky-overwrite'">
      <div class="width-wrapper h-full w-full max-w-[1100px] flex justify-end items-center">
        <div
          v-if="isCableAccessoriesPage || (bagStep == 3 && activeCableSelectionMethods.length < 3 && cablesNeededCount !== totalCablesSubmittedCount) || (cablesNeededCount !== totalCablesSubmittedCount && bagStep === totalSteps -1 && isOnCableSelection) "
          class="w-fit mr-2 text-center md:text-left text-sm md:text-xl font-bold text-blue-default md:py-1/2 md:px-2 cursor-pointer relative"
          @click="showOptions = !showOptions"
        >
          Add Cable Selection Method
          <div v-if="showOptions" class="options-modal">
            <template v-for="method in cableSelectionAvailableOptions[activeProductKey]">
              <div
                :key="method"
                class="method-wrapper w-full flex items-center"
                v-if="!activeCableSelectionMethods.includes(method)"
                @click="addCableSelectionMethod(method)"
              >
                <Plus />
                <p :key="method" class="mt-0 text-blue-dark ml-1/2">{{ method === 'mmy' ? 'Make/Model/Year' : method.toUpperCase() }}</p>
              </div>
            </template>
          </div>
        </div>

        <div v-if="isCableAccessoriesPage && totalCablesSubmittedCount === 0"
          class="w-fit border-1 border-blue-default rounded-full text-sm md:text-xl font-bold text-blue-default py-1/2 px-2 cursor-pointer hover:bg-blue-default hover:text-white inactive"
        >
          {{ mainActionText }}
        </div>
        <div v-else
          class="w-fit border-1 border-blue-default rounded-full text-sm md:text-xl font-bold text-blue-default py-1/2 px-2 cursor-pointer hover:bg-blue-default hover:text-white"
          :class="disabled && 'inactive'"
          @click="mainActionMethod"
        >
          {{ mainActionText }}
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Plus from '../../../utils/icons/plus.vue';
import { UpdateShoppingCartHandlers } from "../../../../mixins/update-shopping-cart-handlers";
import { WebstoreResources } from "../../../../mixins/webstore-resources";
import { cableSelectionAvailableOptions } from '../../../../settings';

export default {
  components: { Plus },
  mixins: [UpdateShoppingCartHandlers, WebstoreResources],
  props: {
    submitButtonText: {
      type: String,
      required: false
    },
    totalSteps: {
      type: Number,
      required: false
    },
    bottomNavIsShown: {
      type: Boolean,
      required: true
    },
    isOnCableSelection: {
      type: Boolean,
      required: false
    },
    activeCableSelectionMethods: {
      required: true,
      type: Array
    },
    isCableAccessoriesPage: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      showOptions: false,
      cableSelectionAvailableOptions: cableSelectionAvailableOptions,
    }
  },
  computed: {
    ...mapGetters([
      "activeProductKey",
      "activeOfferKey",
      "bagStep",
      "activeProductInfo",
      "anonymousLargeFleet"
    ]),

    ...mapGetters("content", [
      "webstoreContent",
    ]),

    ...mapGetters('shoppingCart', [
      'productsInCart',
    ]),

    disabled() {
      if (
        (((this.cablesNeededCount !== this.totalCablesSubmittedCount && this.plugTypeOnly)
        || (this.activeCableSelectionMethods.length === 1 && this.activeCableSelectionMethods.includes('plug type'))) && this.totalSteps !== 3)
        && this.totalCablesSubmittedCount === 0
        ) {
          return true
        }
        return false;
    },

    showBottomNav() {
      if (this.isCableAccessoriesPage && this.bottomNavIsShown) {
        return true
      } else if (this.bagStep > 2 && this.bottomNavIsShown) {
        return true
      } else if (this.onlyOneCableSelectionMethod && this.bagStep > 1 && this.bottomNavIsShown) {
        return true;
      } else {
        return false;
      }
    },


    submitCablesText() {
      let isOfferInCart = this.productsInCart.find(offerInCart => offerInCart.productKey === this.activeProductKey && offerInCart.offerKey === this.activeOfferKey);
      return isOfferInCart ? this.webstoreContent.selectProductsPage.update_selection : this.webstoreContent.selectProductsPage.confirm_cable_selection;
    },

    mainActionText() {
      if(this.anonymousLargeFleet){
        return "Inquire"
      }
      if (this.isCableAccessoriesPage) {
        return this.submitButtonText
      }
      if (this.bagStep < this.totalSteps - 1) {
        if (this.cablesNeededCount == this.totalCablesSubmittedCount || this.plugTypeOnly) {
          return this.webstoreContent.cartPage.next
        } else {
          return this.submitCablesText;
        }
      } else {
        // isCableSelection starts as True, and only gets set to false by cable-selection.vue
        // If there is no cable selection (only 3 total steps), we want to show Add To Bag instead
        if (this.isOnCableSelection && this.totalSteps !== 3) {
          if (this.cablesNeededCount == this.totalCablesSubmittedCount || this.plugTypeOnly) {
            return this.webstoreContent.cartPage.next
          } else {
            return this.submitCablesText;
          }
        } else {
          return this.submitButtonText
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      "setBagStep",
      "setActiveProductTabDefault"
    ]),

    scrollTo(step) {
      this.$emit('scroll-to', step);
    },

    confirmCables() {
      this.$emit('confirm-cables');
    },

    addCableSelectionMethod(method) {
      this.$emit('add-selection-method', method);
    },
    
    mainActionMethod() {
      if(this.anonymousLargeFleet){
        this.$emit('anonymous-inquiry')
        return;
      }
      if (this.isCableAccessoriesPage) {
        this.addToCart();
      }
      if (this.bagStep < this.totalSteps - 1) {
        if (this.cablesNeededCount == this.totalCablesSubmittedCount) {
          if (this.onlyOneCableSelectionMethod) {
            this.scrollTo(this.bagStep + 2);
          } else {
            this.scrollTo(this.bagStep + 1);
          }
        } else {
          this.confirmCables();
        }
      } else {
        // isCableSelection starts as True, and only gets set to false by cable-selection.vue
        // If there is no cable selection (only 3 total steps), we want to show Add To Bag instead
        if (this.isOnCableSelection && this.totalSteps !== 3) {
          if (this.cablesNeededCount == this.totalCablesSubmittedCount) {
            this.scrollTo(this.totalSteps - 1);
          } else {
            this.confirmCables();
          }
        } else {
          this.addToCart();
        }
      }
    },

    addToCart() {
      this.$emit("add-to-cart");
    },
  },
  created() {
    window.onclick = function() {
      this.showOptions = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom-bar-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 90px;
  background-color: white;
  box-shadow: 0px 1px 8px rgba(50, 50, 50, 0.14);
}

.sticky-overwrite {
  position: relative;
  box-shadow: none;
  margin-top: -200px;
  padding: 0;
  margin-bottom: 200px;
}
.inactive {
  opacity: 0.4;
}
.inactive:hover {
  color: rgb(1, 132, 251) !important;
  background: white !important;
}
.active {
  border: 3px solid #0384fb;
}
.options-modal {
  width: 23 0px;
  height: fit-content;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  align-items: center;
  border-radius: 2px;
  box-shadow: 0 2px 8px 1px lightgray;
  position: absolute;
  z-index: 10000;
  right: 50px;
  bottom: 50px;
  padding: 10px;
}
.options-modal p {
  width: 80%;
  text-align: left;
  margin-top: 5px;
  margin-bottom: 5px;
}

.method-wrapper {
  padding-left: 5px;
}

.method-wrapper:hover {
  background-color: #0384fb;
  border-radius: 3px;
}

.method-wrapper:hover p {
  color: white;
}

.method-wrapper:hover ::v-deep svg path {
  fill: white;
}

@media (max-width: 736px) {
  .rounded-full {
    padding: 10px 15px;
    white-space: nowrap;
  }
  .width-wrapper {
    padding: 0 20px;
  }
  .options-modal {
    right: -30px;
  }
}
</style>